///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    engineerCreationHandling,
    engineerDeletionHandling,
    engineerModificationHandling,
    loadPage,
    userCreationHandling,
    userDeletionHandling,
    userModificationHandling
} from '../users-list.actions';
import { map } from 'rxjs/operators';
import { selectUsersPage } from '../users-list.selectors';
import { Store } from '@ngrx/store';
import { concatLatestFrom } from '@ngrx/operators';

@Injectable()
export class UserChangesEffects {
    deletionHandling$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(engineerDeletionHandling, userDeletionHandling),
            concatLatestFrom(() => this.store.select(selectUsersPage)),
            map(([, userPage]) => {
                const isLastPage = Math.trunc(userPage.page.totalElements / userPage.page.size) === userPage.page.number;
                return loadPage({
                    page: isLastPage && userPage.content.length === 1 ? userPage.page.number : userPage.page.number + 1
                });
            })
        );
    });

    creationHandling$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(engineerCreationHandling, userCreationHandling),
            concatLatestFrom(() => this.store.select(selectUsersPage)),
            map(([, userPage]) =>
                loadPage({
                    page: userPage.page.totalElements % userPage.page.size === 0 ? userPage.page.totalPages + 1 : userPage.page.totalPages
                })
            )
        );
    });

    modificationHandling$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(engineerModificationHandling, userModificationHandling),
            concatLatestFrom(() => this.store.select(selectUsersPage)),
            map(([, userPage]) => loadPage({ page: userPage.page.number + 1 }))
        );
    });

    constructor(
        private readonly store: Store,
        private readonly actions$: Actions
    ) {}
}
